<template>
  <div class="device-param-dialog">
    <custom-dialog
      width="1200px"
      :title="model.title"
      :visible="visible"
      v-on="$listeners"
    >
      <div class="dialog-body">
        <custom-table ref="table" type="radio" :data="tslList" height="500px" v-model="historySelect" :loading="isLoading" :column="tableColumn" @filter="filterChange" @sort="sortChange">
        </custom-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">
          {{ $t('Common.com_cancel') }}
        </el-button>
        <el-button type="primary" @click="saveParams">
          {{ $t('Common.com_confirm') }}
        </el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],

  data() {
    return {
      tableColumn: [],
      tslList: [],
      isLoading: false,
      historySelect: {},
      // 用于判断是那个物模型
      componentCode: '',
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.getHistoryList();
    },

    getHistoryList: function () {
      this.isLoading = true;
      this.$getJSON(apis.DeviceResumeParamItemHisList, {
        bodyNum: this.model.bodyNum,
        componentCode: this.model.componentCode,
      }).then((res) => {
        this.isLoading = false;
        const timeColumn = [
          {
            columnName: this.$t('dms_device_param_history_dialog.shang_chuan_shi_jian'),
            columnId: 1,
            columnCode: 'uploadTime',
            selected: true,
            width: 130,
            dicGroup: 'tableField_dateFormat_datetime',
            formatRule: 'tableField_date',
            isFormat: 1
          },
          {
            columnName: this.$t('dms_device_param_history_dialog.ji_lu_shi_jian'),
            columnId: 2,
            columnCode: 'recordTime',
            selected: true,
            width: 130,
            dicGroup: 'tableField_dateFormat_datetime',
            formatRule: 'tableField_date',
            isFormat: 1
          },
        ];
        const tableColumn = res.data.tableColumns;
        tableColumn.forEach((i) => {
          i.columnName = i.dataName;
          i.columnCode = i.dbField;
          i.columnId = i.tslDataId;
          i.selected = true;
          // i.width = '200px';
        });
        this.tableColumn = [...timeColumn, ...tableColumn];
        this.tslList = res.data.dataList || [];
      });
    },
    // 确认保存菜单
    saveParams: function () {
      if (Object.keys(this.historySelect).length > 0) {
        this.$emit('success', this.historySelect);
        this.closeDialog();
      } else {
        this.$message({
          message: this.$t('dms_device_param_history_dialog.qxzlssj'),
          type: 'error',
        });
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
  },
};
</script>

<style lang="scss">
.device-param-dialog {
  .el-input-group__append {
    background-color: #ffffff;
    padding: 0px 6px;
    font-size: 12px;
  }
}
</style>
